import React, { useEffect, useRef, useState } from 'react';
import './RancangBangunVideo.css';

const scenes = [
  { eyebrow: 'PLATFORM KONSTRUKSI TERINTEGRASI', title: 'RancangBangun', sub: 'Dari rencana pertama sampai serah terima.', type: 'intro' },
  { eyebrow: '01 / TEMUKAN PARTNER YANG TEPAT', title: 'Proyek besar\ndimulai dari\nkepercayaan.', sub: 'Owner bertemu kontraktor terverifikasi LPJK — dengan konteks yang jelas sejak awal.', type: 'match' },
  { eyebrow: '02 / RAB & PERENCANAAN', title: 'Anggaran yang\nterukur. Keputusan\nyang mantap.', sub: 'RAB, database material, dan timeline terhubung dalam satu alur kerja.', type: 'rab' },
  { eyebrow: '03 / MONITORING REAL-TIME', title: 'Lapangan tetap\ndalam kendali.', sub: 'Pantau milestone, foto progres, termin, dan risiko — dari mana saja.', type: 'monitor' },
  { eyebrow: 'SATU EKOSISTEM. SATU ARAH.', title: 'Bangun lebih\ncepat. Lebih aman.\nLebih terpercaya.', sub: 'RancangBangun — platform konstruksi Indonesia.', type: 'outro' },
];

const Metric = ({ value, label, className = '' }) => (
  <div className={`metric ${className}`}>
    <strong>{value}</strong>
    <span>{label}</span>
  </div>
);

const ProductFrame = ({ scene }) => (
  <div className={`product-frame ${scene}`}>
    <div className="frame-bar">
      <span className="frame-logo"><i /><span className="wordmark-text">RANCANG<span>BANGUN</span></span></span>
      <span className="frame-status"><b /> LIVE PROJECT</span>
    </div>
    <div className="frame-body">
      <div className="frame-sidebar">
        <div className="side-line active" />
        <div className="side-line" />
        <div className="side-line" />
        <div className="side-line short" />
        <div className="side-line" />
      </div>
      {scene === 'match' && (
        <div className="screen-content match-screen">
          <div className="screen-title">Direktori Kontraktor <small>5 kontraktor · 4 terverifikasi LPJK</small></div>
          <div className="search-bar">Cari nama, lokasi, spesialisasi...</div>
          <div className="filter-row"><b>Semua SBU</b><span>BG001</span><span>BG002</span></div>
          {['PT Karya Beton Nusantara', 'PT Infra Jalan Nusantara', 'PT Bangun Konstruksi Abadi'].map((name, i) => (
            <div className="contractor-row" key={name}><div className="avatar">{['KB', 'IJ', 'BK'][i]}</div><div><strong>{name}</strong><small>{['Jakarta Selatan · 12 tahun', 'Bandung, Jawa Barat · 15 tahun', 'Surabaya, Jawa Timur · 5 tahun'][i]}</small></div><em>{['4.8', '4.6', '4.2'][i]} ★</em></div>
          ))}
        </div>
      )}
      {scene === 'rab' && (
        <div className="screen-content rab-screen">
          <div className="screen-title">RAB Calculator <small>Rumah Tinggal 2 Lantai</small></div>
          <div className="rab-grid"><div><span>Total Estimasi</span><strong>Rp 487.250.000</strong><small>↗ 12,4% dari estimasi awal</small></div><div><span>Item pekerjaan</span><strong>148</strong><small>material & upah</small></div></div>
          <div className="chart"><div className="bar b1" /><div className="bar b2" /><div className="bar b3" /><div className="bar b4" /><div className="bar b5" /><div className="chart-line" /></div>
          <div className="table-lines"><i /><i /><i /><i /></div>
        </div>
      )}
      {scene === 'monitor' && (
        <div className="screen-content monitor-screen">
          <div className="screen-title">Proyek Rumah Tinggal Cilandak <small>Progress keseluruhan</small></div>
          <div className="progress-wrap"><strong>68%</strong><div className="progress-track"><i /></div><span>On track · 32 hari tersisa</span></div>
          <div className="milestones"><div className="done"><b>01</b><span>Struktur</span><em>Selesai</em></div><div className="done"><b>02</b><span>Dinding</span><em>Selesai</em></div><div className="current"><b>03</b><span>MEP</span><em>Berjalan</em></div><div><b>04</b><span>Finishing</span><em>Menunggu</em></div></div>
          <div className="site-card"><div className="site-image" /><div><strong>Laporan lapangan</strong><small>Update hari ini · 14:32</small></div><b>+ 12 foto</b></div>
        </div>
      )}
    </div>
  </div>
);

export default function RancangBangunVideo({ embedded = false }) {
  const [scene, setScene] = useState(0);
  const audioRef = useRef(null);
  const previousSceneRef = useRef(0);

  useEffect(() => {
    const timer = window.setInterval(() => setScene((current) => (current + 1) % scenes.length), 5600);
    return () => window.clearInterval(timer);
  }, []);

  useEffect(() => {
    const audio = audioRef.current;
    if (!audio) return;

    if (scene === 0 && previousSceneRef.current === scenes.length - 1) {
      audio.currentTime = 0;
    }
    previousSceneRef.current = scene;
    audio.play().catch(() => {});
  }, [scene]);

  const current = scenes[scene];
  return (
    <main className={`rb-video${embedded ? ' rb-video-embedded' : ''}`} aria-label="RancangBangun product video">
      <audio
        ref={audioRef}
        src={`${process.env.PUBLIC_URL || ''}/video-assets/rancangbangun-bg.mp3`}
        preload="auto"
        autoPlay
        onEnded={(event) => {
          event.currentTarget.currentTime = 0;
          event.currentTarget.play().catch(() => {});
        }}
      />
      <div className="noise" />
      <div className="orbit orbit-one" />
      <div className="orbit orbit-two" />
      <div className="grid-floor" />
      <div className="persistent-mark"><i /><span className="wordmark-text">RANCANG<span>BANGUN</span></span></div>
      <div className="scene-count">0{scene + 1} <span>/ 05</span></div>
      <div className="scene-progress"><i style={{ width: `${((scene + 1) / scenes.length) * 100}%` }} /></div>
      <section className={`scene scene-${current.type}`} key={current.type}>
        <div className="copy">
          <p className="eyebrow">{current.eyebrow}</p>
          <h1>{current.title.split('\n').map((line, index) => <span key={line}>{line}{index < current.title.split('\n').length - 1 && <br />}</span>)}</h1>
          <p className="sub">{current.sub}</p>
        </div>
        {current.type === 'intro' && <div className="intro-mark"><span>RB</span><b>construction<br />operating system</b></div>}
        {['match', 'rab', 'monitor'].includes(current.type) && <ProductFrame scene={current.type} />}
        {current.type === 'match' && <div className="floating-stamp">VERIFIED<br /><b>LPJK</b></div>}
        {current.type === 'rab' && <Metric value="Rp 487,2 jt" label="estimasi terukur" className="floating-metric" />}
        {current.type === 'monitor' && <Metric value="+24,8%" label="progress bulan ini" className="floating-metric" />}
        {current.type === 'outro' && <div className="outro-lockup"><div className="line" /><span>OWNER · KONTRAKTOR · SUPPLIER · KONSULTAN</span></div>}
      </section>
    </main>
  );
}